export const logNotification = console.log
export const logWarning = console.warn
export const logError = console.error
